export default "__VITE_ASSET__BXAcqUh5__"